/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AgentMemoryControllerCreateMutationRequest, AgentMemoryControllerCreateMutationResponse, AgentMemoryControllerCreate400, AgentMemoryControllerCreate401, AgentMemoryControllerCreate403, AgentMemoryControllerCreate404 } from "../../models/agentMemoriesController/AgentMemoryControllerCreate";

function getAgentMemoryControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/agent-memories` as const }  
  return res
}

/**
 * @summary Create the current user AI agent memory profile
 * {@link /api/v1/agent-memories}
 */
export async function agentMemoryControllerCreate(data?: AgentMemoryControllerCreateMutationRequest, config: Partial<RequestConfig<AgentMemoryControllerCreateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<AgentMemoryControllerCreateMutationResponse, ResponseErrorConfig<AgentMemoryControllerCreate400 | AgentMemoryControllerCreate401 | AgentMemoryControllerCreate403 | AgentMemoryControllerCreate404>, AgentMemoryControllerCreateMutationRequest>({ method : "POST", url : getAgentMemoryControllerCreateUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}